<template>
    <div
        class="absolute top-0 left-0 right-0 bottom-0 h-full w-full "
        @click.prevent="close">
        <popup-overlay>
            <popup-wrapper>
                <button class="modal-popup__close" :aria-lable="$t('POPUP_CLOSE')" @click.prevent="close">
                </button>

                <div class="cz2__modal-popup__header text-base lg:text-2xl lg:tracking-loose">
                    {{title}}
                </div>

                <div class="cz2__modal-popup__body-copy">
                    {{description}}
                </div>

                <button class="cz2__modal-popup__button-ok cz2__modal-popup__group-button" @click.prevent="confirm">
                    {{confirmAction}}
                </button>

                <button
                    v-if="cancelAction && cancelAction.length > 0"
                    class="cz2__modal-popup__button-cancel cz2__modal-popup__group-button" @click.prevent="close">
                    {{cancelAction}}
                </button>
            </popup-wrapper>
        </popup-overlay>
    </div>
</template>

<script>
    import PopupOverlay from './PopupOverlay.vue';
    import PopupWrapper from './PopupWrapper.vue';

    export default {
        components: {
            PopupOverlay,
            PopupWrapper,
        },
        computed: {
            title() {
                return this.$store.state.showGenericConfirm.title;
            },
            description() {
                return this.$store.state.showGenericConfirm.description;
            },
            confirmAction() {
                return this.$store.state.showGenericConfirm.confirmAction;
            },
            cancelAction() {
                return this.$store.state.showGenericConfirm.cancelAction;
            },
        },
        methods: {
            close() {
                this.$store.dispatch('showGenericConfirm', null);
            },

            confirm() {
                if (this.$store.state.showGenericConfirm.confirmationCallback) {
                    this.$store.state.showGenericConfirm.confirmationCallback();
                }

                this.$store.dispatch('showGenericConfirm', null);
            },
        },
    };
</script>
